import { GeneratedStandardReportIdentity } from './generated-standard-report.identity';

export class StandardReportIdentity extends GeneratedStandardReportIdentity {

}
